import { ICommunication } from 'shared/types/redux';

export const initialCommunicationField: ICommunication = { isRequesting: false, error: '', completed: false };
